import React from 'react';
import { ArrowRight, Download } from 'lucide-react';
import images from '../data/images.json';
import { content } from '../data/content';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleDownloadMediaKit = () => {
    window.open(images.mediaKit.pdfUrl, '_blank');
  };

  return (
    <section id="hero" className="relative min-h-[100svh] sm:min-h-screen flex items-center justify-center overflow-hidden pt-24 pb-16 sm:pt-0 sm:pb-0">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={images.hero.main}
          alt={images.hero.alt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-neutral-900/70 via-neutral-900/50 to-neutral-900/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/80 via-transparent to-neutral-900/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-10 animate-fade-in">
          {/* Authority Line */}
          <div className="inline-flex items-center space-x-2">
            <span className="text-amber-200/60 font-medium text-sm tracking-[0.2em] uppercase">
              {content.hero.authorityLine}
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-3xl sm:text-6xl lg:text-8xl font-bold leading-[1.05] sm:leading-tight">
            <span className="text-amber-50">{content.hero.headline}</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-100 to-amber-50">
              {content.hero.subHeadline}
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-2xl text-amber-100/80 max-w-4xl mx-auto leading-relaxed font-light px-1 sm:px-0">
            {content.hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center items-center pt-6">
            <button
              onClick={scrollToContact}
              className="group bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-base sm:px-10 sm:py-5 sm:text-lg rounded-lg font-bold transition-all duration-300 shadow-2xl hover:shadow-red-600/50 hover:scale-105 flex items-center space-x-3"
            >
              <span>{content.hero.cta.primary}</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={handleDownloadMediaKit}
              className="group bg-transparent hover:bg-amber-50/10 backdrop-blur-sm border-2 border-amber-200/30 hover:border-amber-200/50 text-amber-50 px-8 py-4 text-base sm:px-10 sm:py-5 sm:text-lg rounded-lg font-bold transition-all duration-300 flex items-center space-x-3"
            >
              <Download className="w-5 h-5 group-hover:translate-y-1 transition-transform" />
              <span>{content.hero.cta.secondary}</span>
            </button>
          </div>

          {/* Trust Line */}
          <div className="pt-6">
            <p className="text-amber-100/50 text-sm tracking-wide italic">
              {content.hero.trustLine}
            </p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-amber-200/50 rounded-full flex justify-center p-2">
          <div className="w-1.5 h-3 bg-amber-200/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
